<script lang="ts">
    import {onMount} from "svelte";

    // .fa,.fa-brands,.fa-duotone,.fa-light,.fa-regular,.fa-solid,.fa-thin,.fab,.fad,.fal,.far,.fas,.fat
    export let classification = 'fas';

    // ここから選べる
    // https://fontawesome.com/search?m=free
    export let icon: string;

    export let title = '';
    export let isEnablePaddingLeftRight = true;

    const FontAwesomeVersion = 'v6.1.1';

    $: fontAwesomeCssLink = `https://use.fontawesome.com/releases/${FontAwesomeVersion}/css/all.css`;

    onMount(() => {
        if (!document.head.querySelector('#font-awesome-cdn')) {
            const linkElement = document.createElement('link');
            linkElement.setAttribute('href', fontAwesomeCssLink);
            linkElement.setAttribute('rel', 'stylesheet');
            linkElement.setAttribute('id', 'font-awesome-cdn');
            document.head.appendChild(linkElement);
        }
    });

    $: classString = (() => {
        const classArray: string[] = [];
        classArray.push('font-awesome-view');
        classArray.push(classification ? classification : 'fas');
        classArray.push(`fa-${icon}`);
        return classArray.join(' ');
    })();


</script>

<i
        title={title}
        class={classString}
        class:padding-left-right={isEnablePaddingLeftRight}
></i>


<style lang="scss">
    .font-awesome-view {
        font-size: 1em;
        letter-spacing: 0;

        &.padding-left-right {
            padding-left: 0.25em;
            padding-right: 0.25em;
        }


    }
</style>